import { styled } from '@mui/system'
import { fontSizes } from '../../../../Components/consts'

export const SelectorCon = styled('div')(({ theme }) => ({
  fontSize: fontSizes.small,
  fontWeight: 'normal',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'baseline',
  [theme.breakpoints.down('xs')]: {
    justifyContent: 'center',
  },
  '& > div:first-of-type': {
    padding: theme.spacing(0.5, 2),
    marginRight: theme.spacing(1),
  },
}))

type SeasonTypeProps = {
  active: boolean
  disabled?: boolean
}
export const SeasonTypeOuterCon = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  margin: theme.spacing(0, 2),
}))

export const SeasonTypeItemCon = styled('div')<SeasonTypeProps>(
  ({ active, disabled = false, theme }) => ({
    display: disabled === true ? 'none' : 'block',
    fontSize: fontSizes.small,
    fontWeight: active ? 800 : 400,
    margin: theme.spacing(0.5, 2),
    cursor: 'pointer',
  })
)
